import * as React from 'react';
import { SVGProps } from 'react';

const SvgTrx = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx={12} cy={12} r={10} fill="#FF060A" />
    <path
      d="M19.325 9.718c-.656-.606-1.564-1.532-2.304-2.188l-.043-.03a.835.835 0 0 0-.243-.136C14.952 7.03 6.655 5.48 6.493 5.5a.306.306 0 0 0-.127.048l-.041.033a.488.488 0 0 0-.114.184l-.011.028v.18c.934 2.6 4.622 11.12 5.348 13.12.044.136.127.394.283.407h.035c.083 0 .437-.468.437-.468s6.335-7.682 6.976-8.5c.083-.101.156-.21.219-.324a.527.527 0 0 0-.173-.49Zm-5.397.894 2.704-2.242 1.586 1.461-4.29.781Zm-1.05-.146L8.223 6.65l7.532 1.389-2.877 2.426Zm.42 1 4.765-.768-5.447 6.562.682-5.795ZM7.591 7.03l4.898 4.157-.709 6.076L7.591 7.031Z"
      fill="#fff"
    />
  </svg>
);

export default SvgTrx;
